(() => {
  'use strict';
  if (window.gpHabitsMotionMounted) return;
  window.gpHabitsMotionMounted = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const small = matchMedia('(max-width: 760px)');
  const active = new Set();
  const mounted = new WeakSet();
  const turntables = new Set();
  const settle = () => { for (const animation of active) animation.cancel(); active.clear(); for (const jar of turntables) jar.stop(); };
  function animate(element, frames, options) {
    const animation = element.animate(frames, { easing: 'cubic-bezier(.16,1,.3,1)', ...options });
    active.add(animation);
    animation.finished.then(() => active.delete(animation), () => active.delete(animation));
  }
  function mount(section) {
    if (mounted.has(section) || !window.IntersectionObserver || !Element.prototype.animate) return;
    mounted.add(section);
    const heading = section.querySelector('h2');
    const cards = [...section.querySelectorAll('.gp-product-card')];
    const images = cards.map(card => card.querySelector('.gp-product-card__image')).filter(Boolean);
    const prepared = new Map(), pending = new Set();
    let unloaded = false;
    function prepare(image) {
      if (typeof window.gpCreateTurntable !== 'function') return Promise.resolve(null);
      if (!prepared.has(image)) prepared.set(image, window.gpCreateTurntable(image).then(jar => {
        if (unloaded) { jar?.dispose(); return null; }
        if (jar) turntables.add(jar);
        return jar;
      }).catch(() => null));
      return prepared.get(image);
    }
    const nearby = new IntersectionObserver(entries => {
      if (reduce.matches || document.hidden) return;
      for (const entry of entries) if (entry.isIntersecting) { prepare(entry.target); nearby.unobserve(entry.target); }
    }, { rootMargin: '650px 0px' });
    images.forEach(image => nearby.observe(image));
    async function spin(image) {
      if (pending.has(image)) return;
      pending.add(image);
      const jar = await prepare(image);
      pending.delete(image);
      if (unloaded || !jar) { observer.unobserve(image); return; }
      const box = image.getBoundingClientRect();
      const visible = (Math.min(box.bottom, innerHeight - 60) - Math.max(box.top, 0)) / box.height;
      if (visible < .55 || reduce.matches || document.hidden || section.contains(document.activeElement)) return;
      observer.unobserve(image);
      jar.play(small.matches ? 0 : images.indexOf(image) * 140).then(() => { turntables.delete(jar); jar.dispose(); });
    }
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.intersectionRatio < .55) continue;
        const target = entry.target;
        if (reduce.matches || document.hidden || section.contains(document.activeElement)) continue;
        if (target === heading) {
          observer.unobserve(target);
          heading.querySelectorAll('[data-habit-phrase]').forEach((phrase, index) => {
            animate(phrase, [
              { clipPath: 'inset(0 0 85% 0)', transform: 'translateY(14px)' },
              { clipPath: 'inset(0 0 0% 0)', transform: 'translateY(0)' }
            ], { duration: 700, delay: index * 110, fill: 'backwards' });
          });
        } else {
          spin(target);
        }
      }
    }, { threshold: .55, rootMargin: '0px 0px -60px 0px' });
    if (heading) observer.observe(heading);
    images.forEach(image => observer.observe(image));
    section.addEventListener('focusin', settle);
    const unload = event => {
      if (!event.target.contains(section)) return;
      unloaded = true; observer.disconnect(); nearby.disconnect(); settle();
      for (const ready of prepared.values()) ready.then(jar => { if (jar) { turntables.delete(jar); jar.dispose(); } });
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  document.querySelectorAll('[data-habits-motion]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-habits-motion]').forEach(mount);
  });
  reduce.addEventListener('change', () => { if (reduce.matches) settle(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) settle(); });
})();
